import { CtaWrapper, Subtitle, TextContent, Title, Wrapper } from './NotificationBox.styles';
import type { NotificationBoxProps } from './NotificationBox.types';

export function NotificationBox({ title, subtitle, cta }: NotificationBoxProps) {
  return (
    <Wrapper role="region" aria-label={title}>
      <TextContent>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TextContent>
      {cta && <CtaWrapper>{cta}</CtaWrapper>}
    </Wrapper>
  );
}
